import { createApp } from '@app/adapters/create-app'

import SelectRetainedEarningsAccount from '@app/application/components/ledger-import-configuration/select-retained-earnings-account'

onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour~='select-retained-earnings-account']")
    .each(function () {
      createApp(SelectRetainedEarningsAccount, {
        selectedRetainedEarningsAccount: {
          name: this.getAttribute('data-retained-earnings-account-name'),
          number: this.getAttribute('data-retained-earnings-account-number'),
        },
        accountNumberFormSelector: this.getAttribute(
          'data-account-number-form-selector'
        ),
        accountNameFormSelector: this.getAttribute(
          'data-account-name-form-selector'
        ),
      }).mount(this)
    })
})
